import { useRef } from 'react';
import { useIframeContentHeight } from '@bridebook/web/app-shared/lib/ui/hooks/use-iframe-content-height';

interface IProps {
  src: string;
}

export const FirstDanceTracker = ({ src }: IProps) => {
  const ref = useRef<HTMLIFrameElement>(null);
  const height = useIframeContentHeight(ref);

  return (
    <iframe
      ref={ref}
      src={src}
      title="First dance tracker"
      loading="lazy"
      scrolling="no"
      className="block w-full overflow-hidden border-0"
      style={{ height }}
    />
  );
};
